/**
 * **Resort Suite**
 *
 * @exports bs_317
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    /**
       * @memberOf module:bs_317
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve) {
            const lang = window && window.app && window.app.language;
            const aux = lang && lang.substring(0, 2);
            if (aux && ctx.langs.test(aux)) {
                resolve(aux);
                return;
            }
            resolve('en');
        });
    };
    /**
       * @memberOf module:bs_317
       * @see {@link onStateChange}
       *
       * @param {object} ctx - The context object.
       */
    engine.onStateChange = function onStateChange(ctx) {
        setTimeout(thn.pageCheck, 700);
    };
    /**
       * @memberOf module:bs_317
       * @param ctx
       */
    engine.onHashChange = function onHashChange(ctx) {
        // From URP to Booking Confirm changes the hash instead of the pathname
        setTimeout(thn.pageCheck, 800);
    };
    /**
   * @memberOf module:bs_317
      * @this thn.widgets.price
      * @see {@link Price#observe_dom}
      *
      * @param {object} ctx - The context object.
      */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        if (ctx.widget.isSet()) {
            ctx.widget.reset();
        }
    };
    /**
       * @memberOf module:bs_317
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        // Dates
        const dateBegin = (thn.dataLayerHelper.get('ArrivalDate') || '').replace(/-/g, '/');
        const dateEnd = (thn.dataLayerHelper.get('DepartureDate') || '').replace(/-/g, '/');
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = dateBegin.substring(0, 10);
            widgetData.dateEnd = dateEnd.substring(0, 10);
        }
        // Guests, Adults & Children
        widgetData.adults = thn.parseNumber(thn.dataLayerHelper.get('NumAdults')) || 2;
        widgetData.children = thn.parseNumber(thn.dataLayerHelper.get('NumChildren')) || 0;
        widgetData.guests = widgetData.adults + widgetData.children;
        // Prices & Currency || No Rooms
        if (!window.location.href.match(/roomtype\/(INPROMO|INTRO)/)) {
            // This BE has many rates as packages with extras in R&R, so we only take in consideration this two rates above for PW.
            widgetData.priceSpecial = 1;
        }
        const prices = [...document.querySelectorAll('#roomTypeaccordion a span')].map(function (elm) {
            if (elm.textContent.match(/(night|\$)/i)) {
                return thn.parseNumber(elm.textContent);
            }
            return '';
        }).filter(Boolean);
        const currency = thn.parseCurrency((document.querySelector('#roomTypeaccordion a span') || {}).textContent);
        if (prices.length && currency) {
            widgetData.price = Math.min(...prices);
            widgetData.currency = currency;
            widgetData.set = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_317
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        let booking = window && window.app && window.app.data && window.app.data.pmsBookings && window.app.data.pmsBookings;
        if (booking && booking.length) {
            booking = booking[0];
            widgetData.adults = thn.parseNumber(booking.NumAdults);
            widgetData.children = thn.parseNumber(booking.NumChildren);
            widgetData.dateBegin = (booking.ArrivalDate.substring(0, 10) || '').replace(/-/g, '/');
            widgetData.dateEnd = (booking.DepartureDate.substring(0, 10) || '').replace(/-/g, '/');
            widgetData.bookingId = booking.PMSFolioId;
            widgetData.price = thn.parseNumber(booking.NightlyRateIncl || '');
            widgetData.currency = 'USD';
        }
        if (!widgetData.bookingId) {
            const bookingIdEl = window.app.data.gtmCart;
            const bookingId = bookingIdEl && ((Object.keys(bookingIdEl)).toString() || '').replace(/Hotel-/, '');
            widgetData.bookingId = bookingId;
            const price = bookingIdEl && thn.parseNumber(thn.objectGet(window.app.data.gtmCart, 'price') || '');
            widgetData.price = price;
        }
        return widgetData;
    };
    return engine;
}

export { factory };
